import React, {Fragment, useEffect, useState} from 'react';
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader, CardText, Col, Row, Spinner
} from "reactstrap";
import {ArrowLeft, CheckCircle, XCircle} from "react-feather";

import "@styles/react/libs/flatpickr/flatpickr.scss";

import styles from "../styles.module.scss";
import '@styles/react/libs/react-select/_react-select.scss'
import axios from "axios";
import toast from "react-hot-toast";

const ValidationOTP = ({token, stepper, dataOTP, isMobile, userToRegister, onFinish, ids, typeOTP, docId}) => {

    const [otp, setOtp] = useState('');
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);
    const TIME_AWAIT = 1000;
    const BASE_URL = process.env.REACT_APP_API_SERVICE_URL || "https://firma.rubridoc.com/api"

    const verifiedAction = async () => {
        setVerified(false);
        setOtp('');
        setError(null);
        //onFinish(); se comenta este flujo para pruebas de nuevo modulo de factura
        // onFinish();
        stepper.next();
    }

    useEffect(() => {
        window.addEventListener("resize", resize)
        return () => {
            window.removeEventListener("resize", resize)
        };
    }, []);

    const resize = () => {
        setWidth(window.innerWidth);
    }

    const generateInputStyle = () => {

        if (width < 380) {
            return {
                width: '24px',
                height: '24px',
                margin: '0 4px',
                fontSize: '12px',
                borderRadius: '4px',
                border: '1px solid #ccc'
            }
        }

        if (width < 420) {
            return {
                width: '32px',
                height: '32px',
                margin: '0 4px',
                fontSize: '16px',
                borderRadius: '4px',
                border: '1px solid #ccc'
            }
        }

        if (width < 520) {
            return {
                width: '36px',
                height: '36px',
                margin: '0 4px',
                fontSize: '18px',
                borderRadius: '4px',
                border: '1px solid #ccc'
            }
        }

        return {
            width: '3rem',
            height: '3rem',
            margin: '0 6px',
            fontSize: '24px',
            borderRadius: '4px',
            border: '1px solid #ccc'
        }

    }

    const generateContainerStyle = () => {

        if (width < 380) {
            return {
                display: 'inline-flex',
                marginLeft: '-14px'
            }
        }

        if (width < 420) {
            return {
                display: 'inline-flex',
                marginLeft: '-10px'
            }
        }

        if (width < 520) {
            return {
                display: 'inline-flex',
                marginLeft: '-8px'
            }
        }

        return {
            display: 'inline-flex'
        }

    }

    const sendCodeToPhone = async () => {
        try {
            setLoading(true);
            setIsCodeSent(true)
            
            const response = await fetch(`${BASE_URL}/otp/send/${docId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Se envía el token como Bearer
                },
                body: JSON.stringify({})
            });

            if (response.status === 401) {
                toast.error("La sesión ha expirado.");
                return;
            }

            setLoading(false);

        } catch (e) {
            setVerified(false);
            setError(e);
            console.log(e);
            toast.error(`Ha ocurrido un error, favor intente nuevamente o comunicarse con su ejecutivo.`);
        }
        
    }

    const validateOTP = async () => {

        try {

                setLoading(true);
                const uninterceptedAxiosInstance = axios.create()
                const otpValidateResult = await uninterceptedAxiosInstance.post(
                    `${BASE_URL}/otp/validate/${docId}/${otp}`,
                    {}, // Si no tienes cuerpo en la solicitud, puede estar vacío
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );
                if (otpValidateResult.status === 401) {
                    toast.error("La sesión ha expirado.");
                    return;
                }

                setError(null);
                setVerified(true);
                onFinish()
                stepper.next();
        } catch (e) {
            setVerified(false);
            setError(e);
            console.log(e);
            toast.error(`Ha ocurrido un error, favor intente nuevamente o comunicarse con su ejecutivo.`);
        }
        setLoading(false);
    }

    return (
        <div className='col-lg-8 col-md-12 col-sm-12 py-4 m-auto'>
                <Card className={'px-3 py-3'}>
                    <CardHeader>
                        <h2 className="brand-text mb-0 text-primary">RubriDoc</h2>
                        <span className="float-end">Validación de código</span>
                    </CardHeader>
                    <CardBody className={'pb-0'}>
                        <hr />

                        {loading && <div className='row'>
                            <div className='col-12 px-2 py-4 text-center'>
                                <Spinner size='lg'/>
                                <CardText className={'py-1 fs-5'}>Verificando código...</CardText>
                            </div>
                        </div>
                        }

                        {!loading && !error && verified && <div className='row'>
                            <div className='col-12 px-2 text-center'>
                                    <Alert color='success'>
                                        <div className='alert-body py-3'>
                                            <CheckCircle size={32}/>
                                            <h3 className='text-success pt-2'>
                                                Código verificado!
                                            </h3>
                                        </div>
                                    </Alert>
                            </div>
                        </div>
                        }

                        {!loading && !verified && !error && (<Fragment>
                            {
                                !isCodeSent && <>
                                    <Row >
                                        <Col lg={{ size: 12, order: 0 }} md={{ size: 12, order: 0 }} xs={{ size: 12, order: 0 }}
                                            className={'text-center pt-2'}>
                                            <h2>Acceso a visualizar o descargar documento</h2>
                                            <p>Para ingresar al visualizador de documentos de manera segura debe enviar un código OTP a su teléfono </p>
                                            <Button type='button' color='primary' className={'btn-next'}
                                            disabled={isCodeSent}
                                            onClick={sendCodeToPhone}>
                                                <span className='align-middle'>
                                                    {!isCodeSent ? "Enviar código a mi teléfono" : "Código enviado..."}
                                                </span>
                                    </Button>
                                        </Col>
                                    </Row>
                                </>
                            }
                            
                            {
                                isCodeSent && <>
                                    <Col lg={{ size: 12, order: 0 }} md={{ size: 12, order: 0 }} xs={{ size: 12, order: 0 }}
                                        className={'text-center pt-2'}>
                                        <h4>Digita código de validación</h4>
                                        
                                    </Col>
                                    <Row>
                                        <Col lg={{ size: 12, order: 0 }} md={{ size: 12, order: 0 }} xs={{ size: 12, order: 0 }}
                                            className={'text-center pt-3 pb-1'}>
                                            <input placeholder="Dígita Código"
                                                    maxLength={6}
                                                    className={`${styles['input-otp']} text-center`}
                                                    value={otp}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const reg = new RegExp('^[0-9]+$');
                                                        if (!reg.test(value) && value) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            return
                                                        }
                                                        setOtp(e.target.value)
                                            }}/>

                                            {/*<OtpInput
                                                isInputNum={true}
                                                value={otp}
                                                onChange={(e) => setOtp(e)}
                                                numInputs={6}
                                                separator={''}
                                                containerStyle={generateContainerStyle()}
                                                inputStyle={generateInputStyle()}
                                                activeInput={2}
                                                otp={[]}/>*/}

                                        </Col>
                                        <Col lg={{ size: 12, order: 0 }} md={{ size: 12, order: 1 }} xs={{ size: 12, order: 1 }}
                                            className={'text-center py-1 pb-1'}>
                                            <span>Se ha enviado un mensaje con un código de verificación </span>
                                            <br />
                                            <span>a tus dispositivos. Introduce el código para continuar.</span>
                                        </Col>
                                        <Col lg={{ size: 12, order: 0 }} md={{ size: 12, order: 1 }} xs={{ size: 12, order: 1 }}
                                            className={'text-center pb-3'}>
                                            <span onClick={sendCodeToPhone} className={'text-primary cursor-pointer'}>
                                                No he recibido un código
                                            </span>
                                        </Col>
                                    </Row>
                                </>
                            }
                            
                        </Fragment>)}

                        {!loading && !verified && error && <div className='row'>
                            <div className='col-12 px-2 text-center'>
                                    <Alert color='danger'>
                                        <div className='alert-body py-3'>
                                            <XCircle size={32}/>
                                            <h3 className='text-danger pt-2'>
                                                Código invalido!
                                            </h3>
                                        </div>
                                    </Alert>
                            </div>
                            <Col lg={{ size: 12, order: 0 }} md={{ size: 12, order: 1 }} xs={{ size: 12, order: 1 }}
                                 className={'text-center py-1'}>
                                <span onClick={() => {
                                    setVerified(false);
                                    setOtp('');
                                    setError(null);
                                }} className={'text-primary cursor-pointer'}>
                                    Ingresar el código nuevamente
                                </span>
                            </Col>
                        </div>
                        }

                        <hr />
                    </CardBody>
                    <CardFooter className="border-0">
                        <div className='d-flex justify-content-end'>
                            {!error && !verified && <>
                            <Button type='button' color='primary' className={'btn-next'}
                                    disabled={otp?.length !== 6 || loading}
                                    onClick={validateOTP}>
                                <span className='align-middle'>
                                    Finalizar
                                </span>
                            </Button></>}
                        </div>
                    </CardFooter>
                </Card>
        </div>
    );
};

export default ValidationOTP;
